import { render, staticRenderFns } from "./VAudio.vue?vue&type=template&id=2d13c1cd&scoped=true&"
import script from "./VAudio.vue?vue&type=script&lang=ts&"
export * from "./VAudio.vue?vue&type=script&lang=ts&"
import style0 from "./VAudio.vue?vue&type=style&index=0&id=2d13c1cd&lang=scss&scoped=true&"
import style1 from "./VAudio.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d13c1cd",
  null
  
)

export default component.exports